import React, { useEffect, useState } from 'react'
import "./Footer.css";
import { Link } from "react-router-dom";
import footerLogo from './Assets/vli_logo_bw.png'
import VerifyCertificatePopup from './VerifyCertificatePopup';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import { FaWhatsapp } from "react-icons/fa";

const Footer = ({ FooterBgColor, Z_Index, contactUs }) => {

    if (!Z_Index)
        Z_Index = "-z-10"
    return (
        <footer
        //  className={` ${contactUs ? 'md:pt-[12rem] lg:pt-[13rem] xl:pt-[20rem] 2xl:pt-[20rem] 3xl:pt-[25rem] mt-6' : 'pt-[130px] md:pt-[100px] mt-32'} footer-new-class-for-bg bg-backgroundWhiteColor bg-transparent   md:mt-0 w-full gap-4 md:gap-12 lg:gap-24 xl:gap-40 2xl:gap-10 3xl:gap-36 md:max-h-[auto] relative md:h-fit flex flex-col items-center  rounded-t-[50px] md:rounded-t-[0px]  FooterLinearGradient md:overflow-hidden ${Z_Index}`}
         className={` ${contactUs ? 'md:pt-[12rem] lg:pt-[13rem] xl:pt-[20rem] 2xl:pt-[20rem] 3xl:pt-[25rem] mt-6' : 'pt-[130px] md:pt-[400px] mt-32'} footer-new-class-for-bg bg-backgroundWhiteColor bg-transparent   md:mt-0 w-full gap-4 md:gap-12 lg:gap-24 xl:gap-40 2xl:gap-10 3xl:gap-36 md:max-h-[auto] relative md:h-fit flex flex-col items-center  rounded-t-[50px] md:rounded-t-[0px]  FooterLinearGradient md:overflow-hidden `}>


            {!contactUs && <ContactPortionFooter />}
            {/* <MobileScreenFooter /> */}
            <ResponsiveMobileScreenFooter />
            <div className='hidden lg:flex flex-col w-full lg:gap-7 sm:gap-2'>
                <MidFooter />
                <LowerFooter />
            </div>
            <img src={require('./Assets/Footer BG.svg').default}
                className={`2xl:w-full absolute bottom-0 min-h-[550px] 2.5xl:min-h-[600px]  object-cover ${contactUs ? 'w-[130%] lg:w-[120%] 2xl:w-full ' : 'w-[150%] lg:w-[145%]'} -z-[10]  hidden md:inline-block`}

                alt="Footer-BG" />

        </footer>
    )
}
function MobileScreenFooter() {
    return <div className='flex w-full lg:hidden flex-col items-center gap-4'>
        <div className='w-[90%] pt-4 flex flex-wrap list-none gap-3 justify-center text-6xs Regularfont'>

            <Link className='text-white'>Help  </Link> <hr />


            <Link className='text-white'>Search Courses By License Types</Link> <hr />


            <Link className='text-white'> View Special Courses</Link>

        </div>
        {/* <p className='text-6xs text-white Regularfont w-4/5 text-center'>© 2022The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog. Junk MTV quiz graced by fox whelps. Bawds jog, flick quartz, vex nymphs. Waltz, bad nymp</p> */}
        <p className='text-6xs text-white Regularfont w-4/5 text-center'>Vehicle Learning Innovation | 1200 bay st., Suite 1201, Toronto, ON, M5R 2A5 </p>
    </div>
}
function ContactPortionFooter() {
    return <div className=' absolute top-[-100px] lg:top-[100px] 2.5xl:top-[150px] max-w-[525px] w-[80%] xs:w-[60%] sm:w-4/5 px-7 pt-4 pb-7 sm:pb-14 flex flex-col items-center bg-[#A1A3EF] rounded-[20px] text-white gap-4  min-h-[180px] '>
        <h3 className='text-3xs md:text-lg font-normal Regularfont'>
            Contact Us!
        </h3>

        <p className='text-[12px] md:text-xs font-segoe-ui text-center text-pretty Regularfont'>
            We’d love to hear from you!
            Have questions or want to explore how we can help shape your learning journey?
            Reach out to us today!
        </p>
        <Link to='/contact-us' className='z-[9] text-6xs px-8 py-2 m-2 bg-[#333697] Regularfont text-white md:text-base rounded-[50px] border-none cursor-pointer ContactBtn_DropShadow'>
            Contact
        </Link>
       
    </div>
}
function MidFooter() {
    const [showVerifyCertificatePopup, setShowVerifyCertificatePopup] = useState(false)
    let LinkStyle = "text-white Regularfont no-underline text-[21px] cursor-pointer`";
    let ulStyle = "list-none md:flex flex-col justify-start gap-5"
    let iconStyle = "w-full sm:w-[27px] xl:w-[40px]"

    const phoneNumber = "14164779616"; // Your WhatsApp number
    const message = "Hello, I want to chat!"; // Optional prefilled message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return <div className='flex justify-center items-center w-full '>
        <div className='w-[90%] 2.5xl:w-[85%] flex justify-between items-end'>

            <div className='flex gap-[40px] w-[35%]'>
                <div>
                    <ul className={`hidden sm:w-[25%] lg:w-full ${ulStyle}`}>
                        <li className="text-[21px] font-bold text-white">Useful Links</li>
                        <li><Link to='/about' className={`${LinkStyle}`}>About us</Link></li>
                        <li> 
                            <Link to="/#how-vli-add-value" className={`${LinkStyle}`} onClick={() => {
                                const section = document.getElementById("how-vli-add-value");
                                if (section) {
                                    section.scrollIntoView({ behavior: "smooth" });
                                }
                            }}>
                                How Vli Add Value
                            </Link>
                        </li>
                        <li><div       onClick={() => setShowVerifyCertificatePopup(true)}
                        className={`${LinkStyle} cursor-pointer`}>Verify Certificate</div></li>
                        <li><Link className={`${LinkStyle}`}>Latest News</Link></li>
                        <li><Link to='/get-ready/knowledge-test' className={`${LinkStyle}`}>Knowledge Test</Link></li>
                        <li><Link to='/contact-us' className={`${LinkStyle}`}>Contact Us</Link></li>
                    </ul>
                </div>
                <div className={`flex flex-col gap-5`}>
                    <p className="text-[21px] font-bold text-white">About VLI</p>
                    <p className='text-[21px] w-[200px] 2.5xl:w-[300px] text-white'>Canada’s smart platform for driver education. Trusted by thousands of students and driving institutes for its AI tools and certified content.</p>
                </div>
            </div>

            {showVerifyCertificatePopup && (
                <VerifyCertificatePopup 
                    setShowPopup={setShowVerifyCertificatePopup}
                />
            )}

            <div className='w-[30%]'>
                <ul className='list-none flex gap-5 sm:w-[25%] lg:w-full  flex-col items-center w-1/2 md:w-auto my-4'>
                    <li>
                        <img
                            className='w-full md:w-[250px] xl:w-[300px]'
                            src={footerLogo} alt="footer-Logo" />
                    </li>
                    <li className='flex 2xs:gap-3 gap-[15px] items-center justify-center w-full'>
                        <a target='_blank' href='https://www.facebook.com/VehicleLearningInnovation' className='md:w-auto' >
                            <img className={iconStyle} src={require("./Assets/Facebook.svg").default} alt="Facebook-Image" />
                        </a>
                        <a target='_blank' href={'https://www.instagram.com/vehiclelearning'} className='md:w-auto' >
                            <img className={iconStyle} src={require("./Assets/Instagram.svg").default} alt="Instagram-Image" />
                        </a>
                        <a target='_blank' href={'https://www.tiktok.com/@vehiclelearningin'} className='md:w-auto' >
                            <img className={iconStyle} src={require("./Assets/TicktokFooter.svg").default} alt="Ticktok-Image" />
                        </a>
                        <a target='_blank' href={'https://www.youtube.com/@VehicleLearningInnovation'} className='md:w-auto' >
                            <img className={iconStyle} src={require("./Assets/youtube.svg").default} alt="youtube-Image" />
                        </a>

                        {/* <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className='md:w-auto'
                        >
                            <FaWhatsapp size={34} color="#FFFFFF" />
                        </a> */}
                        
                    </li>
                </ul>
            </div>

            <div className='w-[30%]'>
                <ul className={`sm:w-[25%] lg:w-full ${ulStyle} hidden px-1`}>
                    <li><Link className={`${LinkStyle} relative`}>
                        <span className='absolute -left-8'><LocationIcon /></span> 1200 bay st., Suite 1201, Toronto, ON, M5R 2A5</Link>
                    </li>
                    <li><Link className={`${LinkStyle} relative `}><span className='absolute -left-8'><img src={require('./Assets/phone.svg').default} alt="Phone-Image" /></span> +1 416 477 9616</Link></li>
                    <li><Link className={`${LinkStyle} relative `}><span className='absolute -left-8'><img src={require('./Assets/mail.svg').default} alt="Mail-Image" /></span> headoffice@vehiclelearning.com</Link></li>
                </ul>
            </div>
        </div>
    </div>
}
function LowerFooter() {
    const [showPrivacyPolicyPopup, setShowPrivacyPolicyPopup] = useState(false)

    let text = 'text-[21px] text-white  Regularfont font-thin list-none no-underline'
    return <div className='md:flex w-full flex-col gap-4 mb-5 hidden'>
        <hr />
        <div className='flex justify-center items-center w-full'>
            {/* <Link className={`${text}`}>Copyright & Terms And Conditions</Link> */}
            <p className={`${text}`}>© 2025 Vehicle Learning Innovation | Terms | <span className="cursor-pointer"   onClick={() => setShowPrivacyPolicyPopup(true)}
        >Privacy</span></p>
            {/* <span className='flex gap-4 lg:gap-16'>
                <Link className={`${text}`}>
                    Terms of use
                </Link>
                <hr />
                <Link className={`${text}`}>
                    Privacy  Policy
                </Link>
            </span> */}

            {showPrivacyPolicyPopup && (
                <PrivacyPolicy
                    setShowPrivacyPolicyPopup={setShowPrivacyPolicyPopup}
                />
            )}
        </div>
    </div>
}

function LocationIcon({ Classes }) {
    return <svg xmlns="http://www.w3.org/2000/svg" width="21" height="30" viewBox="0 0 21 30">
        <path id="Icon_material-location-on" data-name="Icon material-location-on" className={Classes} d="M18,3A10.492,10.492,0,0,0,7.5,13.5C7.5,21.375,18,33,18,33S28.5,21.375,28.5,13.5A10.492,10.492,0,0,0,18,3Zm0,14.25a3.75,3.75,0,1,1,3.75-3.75A3.751,3.751,0,0,1,18,17.25Z" transform="translate(-7.5 -3)" fill="#fff" />
    </svg>

}

function PhoneIcon({ Classes }) {
    return <svg xmlns="http://www.w3.org/2000/svg" width="21.725" height="21.775" className={Classes} viewBox="0 0 21.725 21.775">
    <path id="Path_94214" data-name="Path 94214" d="M18.435,15.676,16.618,16.7a1.146,1.146,0,0,1-1.373-.189L9.181,10.447a1.147,1.147,0,0,1-.189-1.373l1.024-1.817A1.719,1.719,0,0,0,9.733,5.2L7.01,2.474a1.719,1.719,0,0,0-2.431,0L3.342,3.71a4.585,4.585,0,0,0-.689,5.6l.62,1.034A35.939,35.939,0,0,0,16.261,23.058l.123.07a4.593,4.593,0,0,0,5.546-.722l1.291-1.291a1.719,1.719,0,0,0,0-2.431L20.5,15.959a1.719,1.719,0,0,0-2.06-.283Z" transform="translate(-2 -1.971)" fill="#fff"/>
  </svg>
}

function ResponsiveMobileScreenFooter() {
    const [showVerifyCertificatePopup, setShowVerifyCertificatePopup] = useState(false)
    let iconStyle = "w-[27px]"

    const phoneNumber = "14164779616"; // Your WhatsApp number
    const message = "Hello, I want to chat!"; // Optional prefilled message
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

    return (
     <div className='w-full flex justify-center items-center lg:hidden pb-[20px]'>
          <div className='w-[90%] flex flex-col items-center gap-[10px] text-white'>
                <div className='pt-[0px] flex flex-wrap list-none gap-[10px] justify-center text-[14px] Regularfont'>
                        <Link to='/about' className='text-white'>About us </Link> <hr />
                        <Link to="/#how-vli-add-value" className='text-white' onClick={() => {
                            const section = document.getElementById("how-vli-add-value");
                            if (section) {
                                section.scrollIntoView({ behavior: "smooth" });
                            }
                            }}>
                            How Vli Add Value
                        </Link> <hr />
                        <div       onClick={() => setShowVerifyCertificatePopup(true)}
                        className={` cursor-pointer text-white text-underline`}> Verify Certificate</div>
                        <Link className='text-white'>Latest News</Link> <hr />
                        <Link to='/get-ready/knowledge-test-quiz' className='text-white'>Knowledge Test </Link> <hr />
                        <Link to='/contact-us' className='text-white'>Contact Us</Link> <hr />
                </div>

                <p className='text-[14px] text-center'>Canada’s smart platform for driver education. Trusted by thousands of students and driving institutes for its AI tools and certified content.</p>
                <p className='text-[14px] text-center'>1200 bay st., Suite 1201, Toronto, ON, M5R 2A5</p>

                <div className='w-full flex gap-[10px] items-center justify-center'><img src={require('./Assets/phone.svg').default} alt="phone-Image" className='mt-[5px] w-[20px] h-[20px]' /> <p className='text-[14px]'>+1 416 477 9616</p></div>
                <div className='w-full flex gap-[10px] items-center justify-center'><img src={require('./Assets/mail.svg').default} alt="mail-Image" className='mt-[5px] w-[20px] h-[20px]' /> <p className='text-[14px]'>headoffice@vehiclelearning.com</p></div>

                {/* <p className='text-[14px]'><span><img src={require('./Assets/phone.svg').default} alt="" className='mt-[5px]' /></span> +1 647 948 9811</p>
                <p className='text-[14px]'><span><img src={require('./Assets/mail.svg').default} alt="" className='mt-[5px] w-[15px] h-[15px]' /></span> headoffice@vehiclelearning.com</p> */}
                
                <li className='flex 2xs:gap-3 gap-[15px] items-center justify-center w-full'>
                    <a target='_blank' href='https://www.facebook.com/VehicleLearningInnovation' className='md:w-auto' >
                        <img className={iconStyle} src={require("./Assets/Facebook.svg").default} alt="Facebook" />
                    </a>
                    <a target='_blank' href={'https://www.instagram.com/vehiclelearning'} className='md:w-auto' >
                        <img className={iconStyle} src={require("./Assets/Instagram.svg").default} alt="Instagram" />
                    </a>
                    <a target='_blank' href={'https://www.tiktok.com/@vehiclelearningin'} className='md:w-auto' >
                        <img className={iconStyle} src={require("./Assets/TicktokFooter.svg").default} alt="TicktokFooter" />
                    </a>
                    <a target='_blank' href={'https://www.youtube.com/@VehicleLearningInnovation'} className='md:w-auto' >
                        <img className={iconStyle} src={require("./Assets/youtube.svg").default} alt="youtube" />
                    </a>

                    {/* <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fixed bottom-5 right-5 bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600 transition"
                    >
                        <FaWhatsapp size={34} color="#FFFFFF" />
                    </a> */}
                </li>

                <img
                    className='w-[200px] xl:w-[300px]'
                    src={footerLogo} alt="VLILogo" />

                <p className='text-[14px]'>© 2025 Vehicle Learning Innovation | Terms | Privacy</p>
                
                {showVerifyCertificatePopup && (
                <VerifyCertificatePopup 
                    setShowPopup={setShowVerifyCertificatePopup}
                />
            )}
          </div>
    </div>
    )
}


export default Footer